import React from 'react'
import ReactPlayer from 'react-player'

export type PlayerProps = {
    id: string;
    autoplay: boolean
    source: string;
}

const Player = (props: PlayerProps) => {

    return (
        <div id={props.id} className="player-wrapper">
            <ReactPlayer
                className="player"
                controls
                height='100%'
                loop
                muted
                playing={props.autoplay}
                url={props.source}
                width='100%'
            />
        </div>

    )
}

export default Player